import * as types from "./mutation-types";
import { rankingService } from "@/services";
import { messageHelper } from "@/helpers/message_helper";

export const fetchRankingList = async ({ commit }, params) => {
  commit(types.SET_IS_LOADING, true);

  try {
    const response = await rankingService.list(params);
    commit(types.SET_RANKING_LIST, response.data.data);
    commit(types.SET_TOTAL_ITEMS, response.data.meta.count);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro ao recuperar o ranking");
  } finally {
    commit(types.SET_IS_LOADING, false);
  }
};

// eslint-disable-next-line no-unused-vars
export const getScoreById = async ({ commit }, payload) => {
  let score = {};

  try {
    const reponse = await rankingService.getById(payload);
    score = reponse.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro ao recuperar essa informação");
  }

  return score;
};

// eslint-disable-next-line no-unused-vars
export const getScoreByChallenge = async ({ commit }, payload) => {
  let score = {};

  try {
    const reponse = await rankingService.getByChallenge(payload);
    score = reponse.data;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro ao recuperar essa informação");
  }

  return score;
};
